import { loginStart, loginClearValidationErrors, changeRetailerId } from '../store/login/login.actions';
import { UsernameLogin } from '../components/username-login';
const {
  useCallback,
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useHistory
} = ReactRouterDOM;
export const UsernameLoginContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isIamLoginEnabled = svs.core.detect.feature('ft-iam-login');
  const {
    isLoading,
    isComplete,
    retailerId,
    rememberRetailerId: storeRememberRetailerId,
    validationErrors,
    iamUserNotifications,
    iamParams
  } = useSelector(({
    login
  }) => login);
  const hasIamRedirectContext = Boolean(iamParams?.redirectUri && iamParams?.state);
  useEffect(() => {
    if (!isIamLoginEnabled) {
      return;
    }
    if (!hasIamRedirectContext) {
      window.location.assign('/logga-in/dev-user-login');
      return;
    }
    if (window.location.search !== '?iam=1') {
      history.replace({
        pathname: window.location.pathname,
        search: 'iam=1'
      });
    }
  }, [history, hasIamRedirectContext, isIamLoginEnabled]);
  const hasToChangePassword = useSelector(({
    login
  }) => login.isComplete && login.mustChangePassword);
  const hasValidationErrors = Boolean(validationErrors);
  const handleClearValidationError = useCallback(() => {
    if (hasValidationErrors) {
      dispatch(loginClearValidationErrors());
    }
  }, [dispatch, hasValidationErrors]);
  const handleChangeRetailerId = retailerId => {
    dispatch(changeRetailerId(retailerId));
  };
  const onSubmit = args => {
    dispatch(loginStart(args));
  };
  return <UsernameLogin hasToChangePassword={hasToChangePassword} iamUserNotifications={iamUserNotifications} isComplete={isComplete} isLoading={isLoading} isRememberRetailerIdChecked={storeRememberRetailerId} onChangeRetailerId={handleChangeRetailerId} onClearValidationError={handleClearValidationError} onSubmit={onSubmit} retailerId={retailerId} />;
};